import { getYear, subYears, format, parseISO, parse } from "date-fns";
import { getTodayYMD, getTodayDateTime, getTodayTime } from "../utils/dateUtils";

const monthsMini = [
  "ENE",
  "FEB",
  "MAR",
  "ABR",
  "MAY",
  "JUN",
  "JUL",
  "AGO",
  "SEP",
  "OCT",
  "NOV",
  "DIC"
];

export const actualYearSelect = Array.from({ length: 6 }, (_, index) => {
  const year = getYear(subYears(new Date(), index));
  return { name: year.toString(), value: year };
});

export function formatWithoutHour(fechaCompleta) {
  if (!fechaCompleta) return;

  const fecha = parseISO(fechaCompleta);
  const fechaSinHora = format(fecha, "yyyy-MM-dd");

  return fechaSinHora;
}

export function formatCustomDate(fechaCompleta) {
  if (!fechaCompleta) return "";

  const fecha = parseISO(fechaCompleta);
  const day = format(fecha, "dd");
  const monthIndex = format(fecha, "MM") - 1;
  const year = format(fecha, "yyyy");

  return `${day}/${monthsMini[monthIndex]}/${year}`;
}

export const formatDateOnly = (isoString) => {
  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export function getCurrentDate() {
  return getTodayDateTime();
}

export function formatCustomDateWithHour(fechaCompleta) {
  if (!fechaCompleta) return "";
  const fecha = parse(fechaCompleta, "yyyy-MM-dd HH:mm:ss", new Date());

  const day = format(fecha, "dd");
  const monthIndex = parseInt(format(fecha, "MM")) - 1;
  const year = format(fecha, "yyyy");
  const time = format(fecha, "HH:mm");

  return `${day}/${monthsMini[monthIndex]}/${year} ${time}`;
}

export function getCurrentDay() {
  return getTodayYMD();
}

export function getCurrentTime() {
  return getTodayTime();
}

const pad2 = (n) => String(n).padStart(2, "0");

export const formatAmPm = (t) => {
  if (!t) return "—";
  const [hhS, mmS] = String(t).split(":");
  const hh = Number(hhS ?? 0);
  const mm = Number(mmS ?? 0);
  if (!Number.isFinite(hh) || !Number.isFinite(mm)) return "—";
  const suffix = hh >= 12 ? "PM" : "AM";
  const h12 = ((hh + 11) % 12) + 1;
  return `${h12}:${pad2(mm)} ${suffix}`;
};

export const computeWeeksOfMonth = (year, month) => {
  const result = [];
  if (!year || !month) return result;

  const y = Number(year);
  const mIndex = Number(month) - 1; // 0–11

  // Primer y último día del mes en UTC para evitar desfaces de zona
  const firstOfMonth = new Date(Date.UTC(y, mIndex, 1));
  const lastOfMonth = new Date(Date.UTC(y, mIndex + 1, 0)); // día 0 del mes siguiente

  const firstWeekDay = firstOfMonth.getUTCDay();

  const diffToMonday = (firstWeekDay + 6) % 7; // cuántos días han pasado desde el lunes
  let monday = new Date(firstOfMonth);
  monday.setUTCDate(firstOfMonth.getUTCDate() - diffToMonday);

  while (monday <= lastOfMonth) {
    const weekStart = new Date(monday); // lunes de esa fila
    const friday = new Date(monday);
    friday.setUTCDate(monday.getUTCDate() + 4); // viernes de esa fila

    const rangeStart = new Date(
      Math.max(weekStart.getTime(), firstOfMonth.getTime())
    );
    const rangeEnd = new Date(
      Math.min(friday.getTime(), lastOfMonth.getTime())
    );

    if (rangeStart <= rangeEnd) {
      const startStr = rangeStart.toISOString().slice(0, 10);
      const endStr = rangeEnd.toISOString().slice(0, 10);
      result.push({
        name: `${startStr} a ${endStr}`,
        value: `${startStr} a ${endStr}`
      });
    }

     monday.setUTCDate(monday.getUTCDate() + 7);
  }

  return result;
}

export const buildOpenClosedSelect = (startYear = 2025) => {
  const currentYear = getYear(new Date());
  const from = Number(startYear) || 2025;
  const to = Math.max(currentYear, from);

  return Array.from({ length: to - from + 1 }, (_, i) => {
    const y = from + i;
    return { value: y, name: String(y) };
  });
};

export function formatCustomDateIsoString(isoString) {
    if (!isoString) return "";
    const ymd = isoString.slice(0, 10);
    const [year, month, day] = ymd.split("-");
    const monthIndex = Number(month) - 1;
    return `${day}/${monthsMini[monthIndex]}/${year}`;
}

export function formatMonthYear(value) {
    if (!value) return "";
    let d;
    if (value instanceof Date) {
        d = value;
    } else if (typeof value === "string") {
        const base = value.length >= 10 ? value.slice(0, 10) : value;
        d = new Date(base);
    } else {
        return "";
    }
    const year = d.getFullYear();
    const monthIndex = d.getMonth();
    return `${monthsMini[monthIndex]}/${year}`;
}

export function formatMonthYearIsoString(isoString) {
    if (!isoString) return "";
    const ymd = isoString.slice(0, 10);
    const [year, month] = ymd.split("-");
    const monthIndex = Number(month) - 1;
    return `${monthsMini[monthIndex]}/${year}`;
}
